import { IOTGGalleryData } from 'redhotpie-shared-lib/interfaces/INewFeed';
import * as utils from '../functions/utils';
import { IContentItem } from 'redhotpie-shared-lib/interfaces/ICommunity';

export default class OTGGallery {
  id: number | undefined;
  parrentType: string;
  title: string;
  description: string;
  likeCount: number;
  replyCount: number;
  isMemberLike: boolean;
  galleryImgCount: number | null;
  galleryImgUrls: string[];
  dateCreated: number | string | undefined;
  seoURL?: string;

  constructor() {
    this.id = undefined;
    this.parrentType = '';
    this.title = '';
    this.description = '';
    this.likeCount = 0;
    this.replyCount = 0;
    this.isMemberLike = false;
    this.galleryImgCount = 0;
    this.galleryImgUrls = [];
    this.dateCreated = '';
    this.seoURL = '';
  }

  static mappingObject(_otgGallery: IOTGGalleryData): IContentItem {
    let otgGallery = Object.assign(new OTGGallery(), _otgGallery);
    otgGallery.id = _otgGallery.ID || -1;
    otgGallery.dateCreated = _otgGallery.DateCreated ? _otgGallery.DateCreated : '';
    otgGallery.parrentType = _otgGallery.ParentType ? _otgGallery.ParentType : '';
    otgGallery.title = _otgGallery.Title ? _otgGallery.Title : '';
    otgGallery.description = _otgGallery?.Description || '';
    otgGallery.likeCount = _otgGallery.LikeCount || 0;
    otgGallery.replyCount = _otgGallery.ReplyCount || 0;
    otgGallery.isMemberLike = _otgGallery.IsMemberLike ? _otgGallery.IsMemberLike : false;
    otgGallery.galleryImgCount = _otgGallery.GalleryImgCount ? _otgGallery.GalleryImgCount : null;
    otgGallery.galleryImgUrls = _otgGallery.GalleryImgUrls ? _otgGallery.GalleryImgUrls : [];
    otgGallery.seoURL = _otgGallery.SEOUrl || '';
    otgGallery = utils.cleanObjectKeys(Object.keys(new OTGGallery()), otgGallery);

    return otgGallery;
  }

  static mappingObjects(_data: IOTGGalleryData[]): IContentItem[] {
    return _data.map(item => OTGGallery.mappingObject(item));
  }
}
